import { HdFixingState, HdPlanetKey } from './planet-grid/hd-planet-display-config';

/**
 * Taalonafhankelijke exaltation-/detriment-planeet-keys van één I-Tjing-lijn.
 * De `planet`-velden in `gates/{lang}.json` bevatten `HdPlanetKey`-strings
 * (`'moon'`, `'sun'`, …) of `''` wanneer de lijn geen fixatie-planeet heeft.
 */
export interface HdLineFixingDuality {
  readonly exaltationPlanet: string;
  readonly detrimentPlanet: string;
}

/**
 * Fixatie van een planeet op een lijn: directe vergelijking tussen de
 * planeet-key en de exaltation-/detriment-planeet van de lijn. Gedeeld door
 * het gate-line view-model (activatie-pijltjes) en de maan-transit-berekening
 * (spec `2026-07-06-hd-moon-transit-chart-design.md` §3.5) — enkel wanneer de
 * planeet overeenkomt is die planeet de werkelijke oorzaak van de fixatie.
 */
export function resolveHdPlanetLineFixing(
  planetKey: HdPlanetKey | null,
  line: HdLineFixingDuality,
): HdFixingState {
  if (planetKey == null) {
    return 'none';
  }
  const matchesExaltation = planetKey === line.exaltationPlanet;
  const matchesDetriment = planetKey === line.detrimentPlanet;
  if (matchesExaltation && matchesDetriment) {
    return 'both';
  }
  if (matchesExaltation) {
    return 'exaltation';
  }
  return matchesDetriment ? 'detriment' : 'none';
}
